var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.963 14.2558L16.753 14.2559L21.7426 19.2563L20.2525 20.7462L15.2529 15.7558L15.2529 14.9658L14.983 14.6858C13.8429 15.6657 12.3628 16.2555 10.7528 16.2554C7.16284 16.2551 4.25308 13.3449 4.25337 9.75488C4.25367 6.16488 7.16391 3.25512 10.7539 3.25542C14.3439 3.25571 17.2537 6.16595 17.2534 9.75595C17.2532 11.3659 16.6631 12.8459 15.683 13.9858L15.963 14.2558ZM6.25337 9.75505C6.25317 12.245 8.263 14.2552 10.753 14.2554C13.243 14.2556 15.2532 12.2458 15.2534 9.75578C15.2536 7.26578 13.2437 5.25562 10.7537 5.25542C8.26374 5.25521 6.25358 7.26505 6.25337 9.75505Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24Px);
export default __webpack_public_path__ + "static/media/search_24px.a731ce06224fc68c4f641772938961b4.svg";
export { ForwardRef as ReactComponent };